// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--cogRh","image":"_02712f2b3b--image--FyoPe","title":"_02712f2b3b--title--8wpYj","content":"_02712f2b3b--content--dK6Bm"};